export const EDITOR_CONTROLS = {
  comboboxText: 'ComboboxText',
  dropdownList: 'DropdownList',
  toggleBold: 'ToggleBold',
  toggleItalic: 'ToggleItalic',
  toggleStrike: 'ToggleStrike',
  toggleUnderline: 'ToggleUnderline',
  toggleQuote: 'ToggleQuote',
  buttonDivider: 'ButtonDivider',
  buttonImage: 'ButtonImage',
  toggleLink: 'ToggleLink',
} as const;

export type EditorControl = (typeof EDITOR_CONTROLS)[keyof typeof EDITOR_CONTROLS];
